import { render, staticRenderFns } from "./PreApprovedEmailDomains.vue?vue&type=template&id=3f3fd4da"
import script from "./PreApprovedEmailDomains.vue?vue&type=script&lang=js"
export * from "./PreApprovedEmailDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports